<template>
  <div class="relative">
    <div class="text-sm text-text transition duration-200 flex group cursor-pointer"
         @click="popupOpen = !popupOpen">
      <IconMoreSettings class="text-icon mr-4 group-hover:text-icon-hover transition duration-200"/>
      {{ $t('expenseSettings') }}
    </div>
    <div v-if="popupOpen" class="settings-popup"
         v-on-click-away="hidePopup">
      <div class="text-xl font-bold text-text leading-tight mb-8">{{ $t('expenseSettings') }}</div>
      <BaseSelect :value="defaultExpense"
                  :options="expenses_by_groups"
                  track-by="id"
                  :allow-empty="false"
                  :selectLabel="$t('pickExpenseCategory')"
                  label="title"
                  :group-select="false"
                  :searchable="true"
                  :show-labels="false"
                  group-label="title"
                  group-values="childs"
                  @select="handleSystemSelect"/>

      <div class="text-text-ternary mt-8">{{ $t('expenseCategoryTip') }}</div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import IconMoreSettings from "@/components/icons/IconMoreSettings";
import {directive as onClickAway} from "vue-clickaway";
import BaseSelect from "@/components/UI/BaseSelect/BaseSelect";

export default {
  name: "ExpenseSpaceSettings",
  components: {BaseSelect, IconMoreSettings},
  directives: {
    onClickAway: onClickAway
  },
  data() {
    return {
      popupOpen: false,
      expense:null,
    }
  },
  computed: {
    ...mapGetters('space/expenses', ['expenses_by_groups','defaultExpense']),
  },
  methods: {
    ...mapActions('space/expenses', ['saveDefaultExpenseCategory']),
    ...mapMutations('space/expenses', ['setDefaultExpenseCategory']),
    hidePopup() {
      this.popupOpen = false;
    },
    async handleSystemSelect(expense_category) {
      try {
        const res = await this.saveDefaultExpenseCategory(expense_category.id)
        if (res.body.success) {
          this.setDefaultExpenseCategory(res.body.data);
        }
      } catch (e) {
        console.error(e)
        this.$toasted.error('Ошибка')
      }
    },
  },
  i18n: {
    messages: {
      en: {
        expenseSettings: 'Expense category settings',
        pickExpenseCategory: 'Select default expense category',
        expenseCategoryTip: 'This expense category will be set for all new receipts that will be imported when syncing with banks, if you use this option.',
      },
      ru: {
        expenseSettings: 'Настройки категорий расхода',
        pickExpenseCategory: 'Выберите категорию расхода по умолчанию',
        expenseCategoryTip: 'Эта категория расхода будет устанавливаться для всех новых поступлений, которые будут импортироваться при синхронизации с банками, если вы будете использовать эту возможность.',
      }
    }
  }
}
</script>

<style scoped lang="scss">
.settings-popup {
  @apply absolute -right-16 -bottom-5 z-110 transform translate-y-full
  bg-block shadow-popup p-12 rounded;
  width: 415px;

  &:before {
    content: '';
    @apply absolute bg-block;
    top: -3px;
    right: 24%;
    width: 7px;
    height: 7px;
    transform: rotate(-45deg);
    clip-path: polygon(0 0, 100% 0, 100% 100%);
  }
  @media(max-width: 1229px){
    @apply -right-8;
  }
}
</style>